import { Toaster } from "@/components/ui/toast";
import { Sidebar } from "./layout/sidebar";
import { ToastContainer } from "@/components/ui/toast-container";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="h-screen bg-background flex">
      <Sidebar />
      <main className="flex-1 overflow-hidden flex flex-col">
        {children}
        <Toaster />
      </main>
      <ToastContainer />
    </div>
  );
}